module.exports = __webpack_public_path__ + "static/media/retro.ac2abfc0.mp4";